export default {"src":"/_next/static/media/flowbite_language-outline.640bc0b5.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};